/**
 * Утилита для условного логирования
 * В production окружении логи отключаются для улучшения производительности
 * 
 * Использует import.meta.env.DEV (Vite) - автоматически определяется при сборке
 * В dev режиме (npm run dev): import.meta.env.DEV = true
 * В production сборке (npm run build): import.meta.env.DEV = false
 * 
 * Можно принудительно отключить через переменную окружения VITE_DISABLE_LOGS=true
 */

const isDevelopment = import.meta.env.DEV && import.meta.env.VITE_DISABLE_LOGS !== 'true';

/**
 * Условное логирование - работает только в development
 */
export const devLog = (...args: any[]) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Условное логирование с префиксом - работает только в development
 */
export const devLogWithPrefix = (prefix: string, ...args: any[]) => {
  if (isDevelopment) {
    console.log(`[${prefix}]`, ...args);
  }
};

/**
 * Всегда логирует ошибки (даже в production)
 */
export const logError = (...args: any[]) => {
  console.error(...args);
};

/**
 * Всегда логирует предупреждения (даже в production)
 */
export const logWarn = (...args: any[]) => {
  console.warn(...args);
};

/**
 * DEBUG логирование - работает только в development
 */
export const debugLog = (...args: any[]) => {
  if (isDevelopment) {
    console.log('[DEBUG]', ...args);
  }
};

